import qaData from '../config/qaEmbeddings.json';
import * as tf from '@tensorflow/tfjs';
import * as use from '@tensorflow-models/universal-sentence-encoder';

let modelPromise = null;

async function loadModel() {
  if (!modelPromise) {
    modelPromise = use.load();
  }
  return modelPromise;
}

function cosineSimilarity(vecA, vecB) {
  const dot = vecA.reduce((sum, a, i) => sum + a * vecB[i], 0);
  const magA = Math.sqrt(vecA.reduce((sum, a) => sum + a * a, 0));
  const magB = Math.sqrt(vecB.reduce((sum, b) => sum + b * b, 0));
  return dot / (magA * magB);
}

export async function findBestAnswer(userInput) {
    try {
      const model = await loadModel();
      const embeddings = await model.embed([userInput]);
      const inputVector = (await embeddings.array())[0];
  
      let bestMatch = null;
      let highestScore = -1;
  
      for (const entry of qaData) {
        if (!entry.embeddings || !Array.isArray(entry.embeddings)) continue;
      
        for (let i = 0; i < entry.embeddings.length; i++) {
          const similarity = cosineSimilarity(inputVector, entry.embeddings[i]);
          if (similarity > highestScore) {
            highestScore = similarity;
            bestMatch = {
              answer: entry.answer,
              followUps: entry.followUps || null
            };
          }
        }
      }
      
  
      // 🚨 Add fallback if similarity is low
      if (highestScore < 0.65) {
        return {
          answer: "🤔 I'm not sure about that yet, but I can connect you to a human. Would you like the contact info?",
          followUps: {
            "yes": "📞 You can call us at @tel:+919002333165 or email us @mailto:info@mevedir.com.",
            "contact info": "📞 You can call us at @tel:+919002333165 or email us @mailto:info@mevedir.com.",
            "phone": "📞 You can call us at @tel:+919002333165.",
            "email": "📧 Drop us a mail at @mailto:info@mevedir.com.",
            "whatsapp": "💬 Chat with us @https://wa.link/hm5f3z"
          }
        };
      }
  
      return bestMatch || {
        answer: "Hmm, I couldn't find anything useful. Want to talk to a human?",
        followUps: {
          "yes": "📞 Call us at @tel:+918888888888 or email @mailto:support@mevedir.com."
        }
      };
    } catch (error) {
      console.error('❌ Error in findBestAnswer:', error);
      return {
        answer: "I'm having trouble answering right now. Please try again later."
      };
    }
  }
  
